import React from "react";
import "../Contactus/Contactus.css";
import Connect from "./Connect";
import Location from "../Location/Location";
import { Helmet } from "react-helmet";
const Contactus = () => {
  return (
    <>
      <Helmet>
        {/* ----------------------------------------------------
      BASIC SEO TAGS
  ---------------------------------------------------- */}
        <title>
          Contact ACE Hanei Sector 12 | Sales Office & Inquiry +917303734500
        </title>
        <meta
          name="description"
          content="Contact ACE Hanei Sector 12 sales team at +917303734500. Book site visit, get price details, brochure download for 3.5, 4.5 & 4.5-XL BHK luxury apartments in Noida Extension."
        />
        <meta
          name="keywords"
          content="contact ACE Hanei, ACE Hanei contact number, ACE Hanei sales office, ACE Group contact, book site visit Noida Extension, ACE Hanei inquiry, ACE Hanei booking, ACE Hanei sales team, ACE Hanei Sector 12 contact, luxury apartments contact, ACE Hanei phone number"
        />
        <link rel="canonical" href="https://acegroupsales.com/contactus" />
        <meta name="robots" content="index, follow" />
        <meta name="theme-color" content="#ffffff" />

        {/* ----------------------------------------------------
      OPEN GRAPH TAGS
  ---------------------------------------------------- */}
        <meta
          property="og:title"
          content="Contact ACE Hanei Sales Team | Sector 12 Noida Extension"
        />
        <meta
          property="og:description"
          content="Get in touch with ACE Hanei sales team for site visits, price inquiries, and bookings for luxury 3.5, 4.5 & 4.5-XL BHK apartments in Sector 12 Noida Extension."
        />
        <meta
          property="og:image"
          content="https://acegroupsales.com/poster.webp"
        />
        <meta property="og:url" content="https://acegroupsales.com/contactus" />
        <meta property="og:type" content="website" />

        {/* ----------------------------------------------------
      TWITTER META TAGS
  ---------------------------------------------------- */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Contact ACE Hanei - Luxury Apartments in Noida Extension"
        />
        <meta
          name="twitter:description"
          content="Contact ACE Hanei sales team for inquiries, site visits and bookings. Call +917303734500 for 3.5, 4.5 & 4.5-XL BHK luxury apartments."
        />
        <meta
          name="twitter:image"
          content="https://acegroupsales.com/poster.webp"
        />

        {/* ----------------------------------------------------
      JSON-LD SCHEMA
  ---------------------------------------------------- */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "WebPage",
              name: "Contact ACE Hanei Sales Team - Sector 12 Noida Extension",
              url: "https://acegroupsales.com/contactus",
              description:
                "Contact page for ACE Hanei Sector 12 luxury apartments. Get in touch for site visits, price inquiries, brochure downloads, and booking information for 3.5, 4.5 & 4.5-XL BHK apartments.",
              primaryImageOfPage: {
                "@type": "ImageObject",
                url: "https://acegroupsales.com/poster.webp",
              },
              breadcrumb: {
                "@type": "BreadcrumbList",
                itemListElement: [
                  {
                    "@type": "ListItem",
                    position: 1,
                    name: "Home",
                    item: "https://acegroupsales.com/",
                  },
                  {
                    "@type": "ListItem",
                    position: 2,
                    name: "Contact",
                    item: "https://acegroupsales.com/contactus",
                  },
                ],
              },
              mainEntity: {
                "@type": "ContactPage",
                name: "ACE Hanei Sales Inquiry Form",
                description:
                  "Contact form for ACE Hanei Sector 12 luxury apartments inquiries",
                url: "https://acegroupsales.com/contactus",
                contactType: "Sales Inquiry",
                contactOption: [
                  {
                    "@type": "ContactPoint",
                    telephone: "+917303734500",
                    contactType: "Sales",
                    areaServed: "IN",
                    availableLanguage: ["English", "Hindi"],
                    hoursAvailable: {
                      "@type": "OpeningHoursSpecification",
                      dayOfWeek: [
                        "Monday",
                        "Tuesday",
                        "Wednesday",
                        "Thursday",
                        "Friday",
                        "Saturday",
                      ],
                      opens: "10:00",
                      closes: "19:00",
                    },
                  },
                ],
                hasContactForm: {
                  "@type": "WebForm",
                  name: "ACE Hanei Inquiry Form",
                  description:
                    "Submit your inquiry for ACE Hanei luxury apartments",
                  url: "https://acegroupsales.com/contactus",
                  requiredField: ["Name", "Email", "Mobile"],
                  optionalField: ["Query", "Flat Option"],
                  availableLanguage: ["English", "Hindi"],
                  processingTime: "24 hours",
                },
              },
              about: {
                "@type": "RealEstateAgent",
                name: "Authorized Channel Partner - Shishir",
                telephone: "+917303734500",
                email: "info@acegroupsales.com",
                identifier: "UP RERA Registration No. UPRERAAGT24002",
                address: {
                  "@type": "PostalAddress",
                  streetAddress: "Sector 12",
                  addressLocality: "Greater Noida West",
                  addressRegion: "Uttar Pradesh",
                  addressCountry: "IN",
                },
                geo: {
                  "@type": "GeoCoordinates",
                  latitude: "28.4744",
                  longitude: "77.5040",
                },
                image: "https://acegroupsales.com/poster.webp",
                openingHoursSpecification: {
                  "@type": "OpeningHoursSpecification",
                  dayOfWeek: [
                    "Monday",
                    "Tuesday",
                    "Wednesday",
                    "Thursday",
                    "Friday",
                    "Saturday",
                  ],
                  opens: "10:00",
                  closes: "19:00",
                },
                makesOffer: [
                  {
                    "@type": "Offer",
                    itemOffered: {
                      "@type": "Service",
                      name: "Site Visit Booking",
                    },
                  },
                  {
                    "@type": "Offer",
                    itemOffered: {
                      "@type": "Service",
                      name: "Price Inquiry",
                    },
                  },
                  {
                    "@type": "Offer",
                    itemOffered: {
                      "@type": "Service",
                      name: "Brochure Download",
                    },
                  },
                  {
                    "@type": "Offer",
                    itemOffered: {
                      "@type": "Service",
                      name: "Virtual Tour",
                    },
                  },
                  {
                    "@type": "Offer",
                    itemOffered: {
                      "@type": "Service",
                      name: "Booking Assistance",
                    },
                  },
                ],
              },
              publisher: {
                "@type": "Organization",
                name: "ACE Group",
                url: "https://acegroupsales.com/",
                logo: "https://acegroupsales.com/1.webp",
                description:
                  "ACE Group is a premier real estate developer offering luxury residential projects in prime locations across Noida Extension.",
              },
              mainEntityOfPage: {
                "@type": "FAQPage",
                mainEntity: [
                  {
                    "@type": "Question",
                    name: "How can I contact ACE Hanei sales team?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "You can contact ACE Hanei sales team by calling +917303734500, filling the contact form on this page, or visiting our sales office in Sector 12, Greater Noida West.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "What are the office hours for ACE Hanei sales?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "Our sales office is open from 10:00 AM to 7:00 PM, Monday through Saturday. You can call +917303734500 during these hours for immediate assistance.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "How can I book a site visit for ACE Hanei?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "You can book a site visit by calling +917303734500 or filling the contact form on this page. Our representative will schedule a convenient time for your visit to the project site.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "What information do I need to provide for inquiry?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "For inquiries, please provide your name, email address, mobile number, preferred flat option (3.5, 4.5, or 4.5-XL BHK), and any specific queries you may have.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "Who is the authorized channel partner for ACE Hanei?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "This website is operated by an authorized channel partner of ACE Group - Shishir, with UP RERA Registration No. UPRERAAGT24002. All sales inquiries are handled through this authorized partner.",
                    },
                  },
                ],
              },
              significantLink: [
                "https://acegroupsales.com/",
                "https://acegroupsales.com/pricelist",
                "https://acegroupsales.com/layout",
                "https://acegroupsales.com/about",
              ],
              potentialAction: {
                "@type": "CommunicateAction",
                name: "Call Sales Team",
                target: {
                  "@type": "EntryPoint",
                  urlTemplate: "tel:+917303734500",
                  actionPlatform: [
                    "http://schema.org/DesktopWebPlatform",
                    "http://schema.org/MobileWebPlatform",
                  ],
                },
                expectsAcceptanceOf: {
                  "@type": "Offer",
                  description:
                    "Get information about ACE Hanei luxury apartments",
                },
              },
            }),
          }}
        />
      </Helmet>
      <div className="post-container1">
        <div className="post-image1">
          <img src="contact.webp" alt="ace-hanei-sector-12-noida" />
          <div className="post-overlay1">
            <h1 className="post-heading1">We're Just a Call Away!</h1>
          </div>
        </div>
      </div>

      <Connect />

      <Location />
    </>
  );
};

export default Contactus;
